// Libraries
import { Fragment } from 'react';
import { Flex, Skeleton, Text } from '@chakra-ui/react';
// Types
import { LabelTooltipProps } from './LabelTooltip.type';

/**
 * Renders a tooltip with n labels.
 *
 * @component
 * @param {LabelTooltipProps} props - The component props.
 * @param {string | string[]} props.labels - The label or labels to show.
 * @param {boolean} props.isLoading - Determines if the LabelTooltip is loading.
 * @returns {ReactElement} The rendered component.
 */
export const LabelTooltip = ({ labels, isLoading = false }: LabelTooltipProps) => (
  <Flex alignItems='center' columnGap={1} p={1}>
    {Array.isArray(labels) ? (
      labels.map((label, index) => (
        <Fragment key={label}>
          {index > 0 && (
            <Skeleton isLoaded={!isLoading} fitContent>
              <Text lineHeight='none' variant='faded'>
                |
              </Text>
            </Skeleton>
          )}
          <Skeleton isLoaded={!isLoading} fitContent>
            <Text fontSize={{ base: 'xs' }} lineHeight='none'>
              {label}
            </Text>
          </Skeleton>
        </Fragment>
      ))
    ) : (
      <Skeleton isLoaded={!isLoading} fitContent>
        <Text fontSize={{ base: 'xs' }} lineHeight='none'>
          {labels}
        </Text>
      </Skeleton>
    )}
  </Flex>
);
